import request from '../util/request'

// 获取token
export function signLogin (data) {
  return request({
    url: '/cource-api/single/sign/login',
    method: "GET",
    params: data
  })
}
// 获取用户详细信息
export function getInfo () {
  return request({
    url: '/cource-api/getInfo',
    method: 'get',
  })
}
// 获取菜单
export function getRouters () {
  return request({
    url: '/cource-api/getRouters',
    method: 'get',
  })
}
// // 第三方接口
// export function getPassLogin (data) {
//   return request({
//     url: '/pass/third_account_login',
//     method: 'get',
//     params: data
//   })
// }
